import type { MonoIconType } from '@/components/ui/icon';

/** Icon names stored in DB; map to SVG icon types for display. */
export const PICKER_ICON_NAMES = [
  'Circle',
  'CircleDot',
  'CheckCircle',
  'Clock',
  'AlertCircle',
  'Flag',
  'Tag',
  'Bookmark',
  'Star',
  'Zap',
  'MessageSquare',
  'Ticket',
  'ListTodo',
  'SignalZero',
  'SignalLow',
  'SignalMedium',
  'SignalHigh',
  'SignalMax'
] as const;

export type PickerIconName = (typeof PICKER_ICON_NAMES)[number];

/** Map DB icon names to SVG icon types (some Lucide names differ). */
const PICKER_TO_SVG: Record<string, MonoIconType> = {
  Circle: 'Circle',
  CircleDot: 'CircleDot',
  CheckCircle: 'CheckCircle',
  Clock: 'Clock',
  AlertCircle: 'AlertCircle',
  Flag: 'Flag',
  Tag: 'Tag',
  Bookmark: 'Bookmark',
  Star: 'Star',
  Zap: 'Bolt',
  Bolt: 'Bolt',
  MessageSquare: 'MessageCircle',
  MessageCircle: 'MessageCircle',
  Ticket: 'Ticket',
  ListTodo: 'QueueList',
  QueueList: 'QueueList'
};

export function getPickerIcon(name: string | undefined): MonoIconType | undefined {
  if (!name) return undefined;
  return PICKER_TO_SVG[name] ?? (PICKER_ICON_NAMES.includes(name as PickerIconName) ? (name as MonoIconType) : undefined);
}
